import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";
import { EditarNomina, GuardarNomina } from "../../../../API/RRHH/Maestros/MaestrosRequest";


const NominasCRUD = ({
  showDialog,
  setShowDialog,
  getInfo,
  selected,
  setSelected,
  modo
}) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [responsabilidad, setResponsabilidades] = useState([]);
  const [habilidades, setHabilidades] = useState([]);
  const [monedas, setMonedas] = useState([]);

  const initialValues = {
    IdPosicion: -1,
    Posicion: "",
    Description: "",
    IdStatus: selected ? selected?.IdStatus  : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const monedasTempo = await ObtenerCurrency("General");
    setMonedas(monedasTempo);



    if(selected[0]?.IdNomina > 0){
      setValues({
        ...selected[0],
      });

    }else{
      setValues(initialValues);
    }

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    getInfo()
    setSelected([])
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Nomina) {
      error.Nomina = true;
      error.error = true;
    }
    if (!values.Horas) {
        error.Horas = true;
        error.error = true;
    }
    if (!values.Currency.IdCurrency && !values?.IdCurrency) {
      error.IdCurrency = true;
      error.error = true;
    }

    setError(error);
    return error;
  };

  const agregarPlanilla = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const Datos = {
        IdNomina: selected[0]?.IdNomina ? selected[0]?.IdNomina : -10,
        Nomina: values?.Nomina,
        Horas: values?.Horas,
        Descripcion: values.Descripcion,
        IdCurrency: values.Currency?.IdCurrency || values?.IdCurrency,
      };

      if(Datos.IdNomina > 0){
        setLoading(true)
        const resultado = await EditarNomina(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow(toast,"success","Datos Editados",resultado[0]?.MENSAJE );
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }else{
        const resultado = await GuardarNomina(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Editar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {agregarPlanilla();}}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Planilla" : "Editar Planilla";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: '50%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div>
            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Nomina"
                    value={values.Nomina}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Nomina ? "p-invalid" : ""}
                  />
                  <label htmlFor="Nomina">Planilla</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>

            </div>

            <div className="d-flex mx-4">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputNumber
                            name="Horas"
                            value={values.Horas}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            minFractionDigits={2}
                            className={error.Horas ? "p-invalid" : ""}
                        />
                        <label htmlFor="Horas">Horas</label>
                    </span>
                </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Currency"}
                    value={values.Currency}
                    items={monedas}
                    field={"Currency"}
                    label={"Moneda"}
                    handleInputChange={handleInputChange}
                    className={error.IdCurrency ? "p-invalid" : ""}
                  />
                </span>
              </div>

            </div>
          </div>
        </div>
      </Dialog>

      
    </div>
  );
};

export default NominasCRUD;
